import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Rating from "../review/Rating";
import { useLanguage } from '../../context/LanguageContext';

const TestimonialThree = () => {
  const { t } = useLanguage();

  const swiperOption = {
    slidesPerView: 2,
    speed: 700,
    spaceBetween: 30,
    slidesPerGroup: 2,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  };

  const testimonials = [
    {
      image: "assets/img/gui.png",
      alt: "user 1"
    },
    {
      image: "assets/img/jorgeFoto.jpeg",
      alt: "user 2"
    }
    // {
    //   image: "assets/img/testimonial/app-testimonial-3.png",
    //   alt: "user 3"
    // }
  ];

  return (
    <>
      <section className="cutomer-review-app-two ptb-20">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8 col-12">
              <div className="mb-4 mb-sm-5">
                <h2>{t('testimonials.title')}</h2>
                <p className="m-0">
                  {t('testimonials.subtitle')}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="appTwoReviewSwiper">
                <Swiper {...swiperOption}>
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <div className="single-review-slider p-lg-5 p-4 bg-white rounded-custom border my-lg-4 col-10">
                        <Rating />
                        <h5 className="h6">{t(`testimonials.reviews.${index}.title`)}</h5>
                        <p>
                          {t(`testimonials.reviews.${index}.text`)}
                        </p>
                        <div className="d-flex align-items-center">
                          <img
                            src={testimonial.image}
                            className="img-fluid me-3 rounded-circle"
                            width={50}
                            height={50}
                            alt={testimonial.alt}
                          />
                          <div className="author-info">
                            <h6 className="mb-0">{t(`testimonials.reviews.${index}.author`)}</h6>
                            <small>{t(`testimonials.reviews.${index}.role`)}</small>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialThree;
